import React from 'react'
import {
  Form, Button, FormGroup, Label, Col, Card,
  CardBody, CardTitle, CardText
} from 'reactstrap'

export default class AccountForm extends React.Component {
  constructor(props){
    super(props)
    this.state = {edit: false, values: props.account || {}}
  }

  static getDerivedStateFromProps(props, state) {
    if(!state.edit && props.account) {
      return {...state, values: props.account}
    }
    return null
  }

  toggle = (e) => {
    e.preventDefault();
    this.setState({edit: !this.state.edit})
  }

  handleChange = (e) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    if(value === 'true') value = true
    if(value === 'false') value = false
    if(e.target.name === 'sharedWith') {
      value = (value || '').split(',')
    }
    const values = {...this.state.values, [e.target.name]: value}
    this.setState({values})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({isSubmitting: true})
    const values = {sharedWith: this.state.values.sharedWith}
    this.props.submit(values).then(() =>
      this.setState({edit:false, isSubmitting:false})
    ).catch(error => this.setState({isSubmitting: false}))
  }

  render(){
    return(
      <Form onSubmit={this.handleSubmit}>

        <Card className="m-b-20">
          <CardBody>
            <CardTitle>
              Einstellungen{' '}
              <a href="#" onClick={this.toggle} className="float-right">
                {!this.state.edit
                  ?
                  <i className="fas fa-pencil-alt"/>
                  :
                  <i className="fas fa-window-close"/>
                }
              </a>
            </CardTitle>
            <CardText tag="div">
              {this.props.account &&
                <React.Fragment>

                  <FormGroup row>
                    <Label sm="3" for='name'>Name</Label>
                    <Col sm="9">
                      <input
                        readOnly
                        className="form-control-plaintext"
                        type="text"
                        name='name'
                        defaultValue={this.state.values.name}/>
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label for='id' sm="3">ID</Label>
                    <Col sm="9">
                      <input
                        readOnly
                        type="text"
                        className="form-control-plaintext"
                        defaultValue={this.state.values.id}/>
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label for='createdAt' sm="3">Erstellt am</Label>
                    <Col sm="9">
                      <input
                        readOnly
                        type="text"
                        name='createdAt'
                        className="form-control-plaintext"
                        defaultValue={this.state.values.createdAt || ''}/>
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label for='sharedWith' sm="3">Zugang für</Label>
                    <Col sm="9">
                      <input
                        type="text"
                        name='sharedWith'
                        readOnly={!this.state.edit}
                        className={`form-control${!this.state.edit ? '-plaintext' : ''}`}
                        id='sharedWith'
                        onChange={this.handleChange}
                        value={this.state.values.sharedWith || ''}/>
                    </Col>
                  </FormGroup>
                </React.Fragment>
              }
            </CardText>
            {this.state.edit &&
              <React.Fragment>
                <Button
                  color="primary"
                  disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? 'Bitte warten...' : 'Übernehmen'}
                 </Button>{' '}
                 <Button color="secondary" onClick={this.toggle}>Abbrechen</Button>
              </React.Fragment>
            }
          </CardBody>
        </Card>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/AccountForm.js